import { app } from '@/config/index.js'
import { valueOrDefault } from '@/utils/common.js'
import { getLocalStorageData } from '@/utils/storage.js'

const BLIBLI_TENANT_ID = 'BLIBLI'

export const getBlibliTiketOriginSource = () => {
  return valueOrDefault(getLocalStorageData(app.localStorage.blibliTiketOriginSource), BLIBLI_TENANT_ID)
}
